import { useEffect } from 'react';
import { ReactComponent as Online } from '@zonofi/svg-icons/online-icon.svg';
import { ReactComponent as Offline } from '@zonofi/svg-icons/offline-icon.svg';
import { dispatch, updateIsOnline } from '@zonofi/zono-money-store';
import { useNetworkContext } from './network-context-provider';

export interface NetworkStatusProps {
  iconProps?: React.SVGProps<SVGSVGElement>;
}
export const NetworkStatus: React.FC<NetworkStatusProps> = ({ iconProps }) => {
  const { networkStatus } = useNetworkContext();

  return networkStatus ? <Online {...iconProps} /> : <Offline {...iconProps} />;
};
